import createIcon from '../../createIcon';

/**
 * @component @name NearMe
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMjcgNi43M0wxMy4wMyAxNi44NkwxMS4zOSAxMi42MUwxMC41NyAxMi4yOUw3LjE0IDEwLjk2TDE3LjI3IDYuNzNaTTIxIDNMMyAxMC41M1YxMS41MUw5Ljg0IDE0LjE2TDEyLjQ4IDIxSDEzLjQ2TDIxIDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NearMe = createIcon('NearMe', [
  [
    'path',
    {
      d: 'M17.27 6.73L13.03 16.86L11.39 12.61L10.57 12.29L7.14 10.96L17.27 6.73ZM21 3L3 10.53V11.51L9.84 14.16L12.48 21H13.46L21 3Z',
      key: 'pl7m24',
    },
  ],
]);

export default NearMe;
